import React from "react";
import { PickerDesktop } from "../Picker";
import CurrencySign from "./CurrencySign";
import "./CurrencyPicker.types";
var CurrencyPickerDesktop = function (props) {
    var children = props.children, currencySelection = props.currencySelection, selectedCurrencyId = props.selectedCurrencyId, attributes = props.attributes, triggerAttributes = props.triggerAttributes, onOpen = props.onOpen, onClose = props.onClose;
    var renderSign = function (item) {
        var active = item.id === selectedCurrencyId;
        return React.createElement(CurrencySign, { text: item.sign, active: active });
    };
    var renderSelectedSign = function (item) { return item.sign; };
    return (React.createElement(PickerDesktop, { multilineItems: true, selection: currencySelection, selectedId: selectedCurrencyId, attributes: attributes, triggerAttributes: triggerAttributes, renderSign: renderSign, renderSelectedSign: renderSelectedSign, onOpen: onOpen, onClose: onClose }, children));
};
export default CurrencyPickerDesktop;
